// extracted by mini-css-extract-plugin
export default {"modal":"shareJobModal_modal__nTWrV","modalBody":"shareJobModal_modalBody__tX5gq"};